<template>
  <v-card flat tile fill-height>
    <v-card-title style="height: 80px" class="py-0 my-0">
      <span class="title">车辆绑定</span>
    </v-card-title>
    <v-card-text>
      <v-container class="pt-0">

        <v-form ref="form">
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                v-model="type"
                :rules="$rules.required('请选择车辆类型')"
                prepend-icon="$vuetify.icons.idCardType"
                :items="vehicleTypeItems"
                label="车辆类型"
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="type === 'org_ve'">
              <v-text-field
                prepend-icon="$vuetify.icons.org"
                label="所在单位"
                disabled
                v-model="$store.state.login.self.orgName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <l-plate-picker v-model="plate" required></l-plate-picker>
            </v-flex>
          </v-layout>
        </v-form>

        <v-subheader v-if="type === 'per_ve'||needDriverLicense">驾驶证*</v-subheader>
        <v-layout justify-center v-if="type === 'per_ve'||needDriverLicense" column>
          <l-select-file @input="addFile($event, DLImages)" ref="file1">
            <v-btn color="primary" flat slot="activator" :disabled="DLImages.length===1||disabledFlag">
              上传驾驶证<span class="error--text caption" >（至多只上传一张图片）</span>
            </v-btn>
          </l-select-file>
          <l-image v-if="DLImages.length === 0"></l-image>
          <l-image-dialog :src="img.src" :key="i" v-for="(img, i) in DLImages">
            <l-image
              :src="img.src"
              :loading="img.loading"
              slot="activator"
            >
              <template slot="action">
                <v-btn slot="activator" @click="deleteImage(DLImages, i)" icon>
                  <v-icon>$vuetify.icons.delete</v-icon>
                </v-btn>
              </template>
            </l-image>
          </l-image-dialog>
        </v-layout>

        <v-subheader v-if="type === 'per_ve'||needPassLicense">行驶证*</v-subheader>
        <v-layout justify-center v-if="type === 'per_ve'||needPassLicense" column>
          <l-select-file @input="addFile($event, RLImages)" ref="file1">
            <v-btn color="primary" flat slot="activator" :disabled="RLImages.length===1||disabledFlag">
              上传行驶证<span class="error--text caption" >（至多只上传一张图片）</span>
            </v-btn>
           <!-- <l-image
              no-image-text="点击添加"
              slot="activator" v-if="!RLImages.length"></l-image>-->
          </l-select-file>
          <l-image v-if="RLImages.length === 0"></l-image>
          <l-image-dialog :src="img.src" :key="i" v-for="(img, i) in RLImages">
            <l-image
              :src="img.src"
              :loading="img.loading"
              slot="activator"
            >
              <template slot="action">
                <v-btn slot="activator" @click="deleteImage(RLImages, i)" icon>
                  <v-icon>$vuetify.icons.delete</v-icon>
                </v-btn>
              </template>
            </l-image>
          </l-image-dialog>
        </v-layout>

        <v-subheader v-if="type === 'per_ve'">其他证明</v-subheader>
        <v-layout justify-center v-if="type === 'per_ve'" column>
          <l-select-file @input="addFile($event, OtherImages)" ref="file1">
            <v-btn color="primary" flat slot="activator" :disabled="OtherImages.length===1||disabledFlag">
              上传其他证明<span class="error--text caption" >（至多只上传一张图片）</span>
            </v-btn>
          </l-select-file>
          <l-image v-if="OtherImages.length === 0"></l-image>
          <l-image-dialog :src="img.src" :key="i" v-for="(img, i) in OtherImages">
            <l-image
              :src="img.src"
              :loading="img.loading"
              slot="activator"
              persistent-action
            >
              <template slot="action">
                <v-btn slot="activator" @click="deleteImage(OtherImages, i)" icon>
                  <v-icon>$vuetify.icons.delete</v-icon>
                </v-btn>
              </template>
            </l-image>
          </l-image-dialog>
        </v-layout>
      </v-container>
      <v-layout justify-center>
        <v-btn :loading="loading" @click="submit" large color="primary" :disabled="disabledFlag">提交</v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import LPlatePicker from '../../components/LPlatePicker'
import {Image} from '@/object'
import wx from 'weixin-js-sdk'

export default {
  name: 'vehicleBindWX',
  components: {LPlatePicker},
  data: () => ({
    vehicleTypeItems: [
    ],
    type: '',
    plate: '',
    loading: false,
    disabledFlag:false,
    DLImages: [],
    RLImages: [],
    OtherImages: [],
    needDriverLicense:false,
    needPassLicense:false,
  }),
  async created () {
    await this.$store.dispatch('login/getSelfInfo')
    await this.$store.dispatch('login/getPermission')
    this.dealPermission()
  },
  methods: {
    closeWindow () {
      wx.closeWindow()
    },
    async dealPermission(){
      let permission = this.$store.state.login.permission
      if (permission.vehicle !== undefined && permission.vehicle.user !== undefined) {
        this.vehicleTypeItems.push({
          value: 'per_ve',
          text: '校内用户车辆'
        })
      }
      if (permission.vehicle !== undefined && permission.vehicle.org !== undefined) {
        this.vehicleTypeItems.push({
          value: 'org_ve',
          text: '校内用户车辆'
        })
      }
      if (permission.vehicle !== undefined && permission.vehicle.partner !== undefined) {
        this.vehicleTypeItems.push({
          value: 'coo_ve',
          text: '合作用户车辆'
        })
        await this.hasDriverLisense()
      }
      if(this.vehicleTypeItems.length!==0){
        this.type = this.vehicleTypeItems[0].value
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0)
        return false
      }
      if ((this.DLImages.length === 0 && this.type === 'per_ve')||(this.DLImages.length === 0 && this.needDriverLicense)) {
        this.$L.alert('error snackbar', {message: '未上传驾驶证'})
        return false
      }
      if (this.RLImages.length === 0 && (this.type === 'per_ve'||this.needPassLicense)) {
        this.$L.alert('error snackbar', {message: '未上传行驶证'})
        return false
      }
      try {
        await this.$store.dispatch('wx/bindVehicle', {
          type: this.type,
          plate: this.plate,
          DLImages: this.DLImages,
          RLImages: this.RLImages,
          OtherImages: this.OtherImages
        })
        this.$L.success('提交成功')
        this.disabledFlag = true
      }
      catch (e) {
        this.$L.error(e.message)
      }
      finally {
        this.loading = false
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async hasDriverLisense(){
      let p = await this.$store.dispatch('login/getSelfInfo')
      if(p.driverLicense.length===0){
        this.needDriverLicense = true
      }
    },
    async hasPassLisense(){
      let p = await this.$store.dispatch('login/getSelfInfo')
      let res = await this.$store.dispatch('wx/checkPassLicense',{id:p.driverOrgs[0],plate:this.plate})
      if(res.data.status === 2){
        this.needPassLicense = true
      }
    },
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      let suffix = path[0] === '/' ? path.slice(1) : path
      try {
        let data = await this.$store.dispatch('downloadFile', {url: `/passApi/${suffix}`})
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$set(img, 'src', e.target.result)
          // console.log(img, e.target)
        }
        reader.readAsDataURL(data)

        // console.log('get Img success', src)
      }
      catch (e) {
        img.error = true
        img.errorMessage = e.message
      }
      img.loading = false
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        // 上传图片
        this.disabledFlag = true
        let img = await this.uploadFile(file)
        this.disabledFlag = false
        if(img.url!==''){
          target.push(temp)
          this.$set(target, target.length - 1, img)
          this.getImg(img)
        }
      }
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    }
  },
  watch:{
    plate(){
      if(this.plate.length===7||this.plate.length===8){
        this.hasPassLisense()
      }
    }
  }
}
</script>

<style scoped>

</style>
